module.exports = __webpack_public_path__ + "static/media/horizontalRectangle_white.d8670042.svg";